import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import QuestionCircle from '@decisiv/iconix/lib/components/QuestionCircle';
import SearchInput from '@decisiv/ui-components/lib/components/SearchInput';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import { SearchArea, SearchHint } from './styles';

export const SEARCH_HINT = 'Search by name, username, or email.';

/**
 * The users list's search box (PD-4063).
 *
 * searchOn="submit" — the Figma component is named "Search on Submit", so this
 * searches on Enter rather than per keystroke, unlike the filter menus' "Search
 * as you type". That also suits the query behind it, which scans five columns.
 *
 * Clearing the field searches again immediately, so emptying the box restores the
 * full list without needing another Enter.
 */
function UsersSearch({ onSearch, value }) {
  const [draft, setDraft] = useState(value);

  // Keeps up with the applied term when it changes elsewhere, e.g. Clear All.
  useEffect(() => setDraft(value), [value]);

  const handleChange = (event) => {
    const next = event.target.value;
    setDraft(next);
    if (next === '') onSearch('');
  };

  return (
    <SearchArea>
      <SearchInput
        hideLabel
        label="Search users"
        searchOn="submit"
        size="small"
        value={draft}
        onChange={handleChange}
        onSearch={onSearch}
      />
      <SearchHint>
        <QuestionCircle size="small" />
        <P shade={1} size="small">
          {SEARCH_HINT}
        </P>
      </SearchHint>
    </SearchArea>
  );
}

UsersSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  /** The term currently applied to the list. */
  value: PropTypes.string,
};

UsersSearch.defaultProps = {
  value: '',
};

export default UsersSearch;
